export default {
  install: function (Vue,) {
    Vue.directive('f-dropdown-menu', {
      bind(el) {
        new Foundation.DropdownMenu($(el))
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-off-canvas', {
      bind(el) {
        new Foundation.OffCanvas($(el), {transitionTime: 500})
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-slider', {
      bind(el) {
        new Foundation.Slider($(el))
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-tabs', {
      bind(el) {
        new Foundation.Tabs($(el))
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-dropdown', {
      inserted(el) {
        $(el).foundation();
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-accordion', {
      bind(el) {
        new Foundation.Accordion($(el))
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })
    Vue.directive('f', {
      bind(el) {
        $(el).foundation();
      },
      unbind(el) {
        $(el).foundation('destroy');
      }
    })

    Vue.directive('f-nd', {
      bind(el) {
        $(el).foundation();
      },
    })

    Vue.prototype.$confirm = function (title, message, callback, extra = '') {
      var modal = '<div class="reveal small" id="confirmation">' +
        '<h2>' + title + '</h2>' +
        '<p class="lead">' + message + '</p>' +
        '<div class="content">'
        + extra +
        '</div> ' +
        '<button class="button success yes">Yes</button>' +
        '<button class="button alert float-right" data-close>No</button>' +
        '</div>';
      // appending new reveal modal to the page
      $('body').append(modal);
      // registergin this modal DOM as Foundation reveal
      var confirmation = new Foundation.Reveal($('#confirmation'));
      // open
      confirmation.open();
      // listening for yes click

      $('#confirmation').children('.yes').on('click', function () {
        // close and REMOVE FROM DOM to avoid multiple binding
        confirmation.close();
        $('#confirmation').remove();
        // calling the function to process
        callback.call();
      });
      $(document).on('closed.zf.reveal', '#confirmation', function () {
        // remove from dom when closed
        $('#confirmation').remove();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/plugins/foundation.js